import { HashRouter, Redirect, Route, Switch, Link, useLocation } from "react-router-dom";
import {useAuth} from './contexts/authContext'
import Landing from "./pages/Landing";
import Series from "./pages/Series";
import Question from "./pages/Question";
import Result from "./pages/Result";
import SignUp from "./pages/Auth/SignUp";
import Login from "./pages/Auth/Login";
import "./App.css";

const ShouldBeLoggedIn = ()=>{
  const location = useLocation();
  return <div style={{display:"flex",flexDirection:"column", justifyContent:"center", alignItems:"center",textAlign:"center", height:"100%", width:"100%"}}>
    <div >

    <h1>عليك تسجيل الدخول للمواصلة <br/>و الحصول على النتيجة مع التصحيح</h1>
    <span style={{display:"flex", justifyContent:"space-evenly", marginTop:"4rem"}}>
      <Link 
         to={{
          pathname: "/",
          state: { from: location }
        }}
        // style={{textDecoration:"none", padding:"0.5em 1em", backgroundColor:"#35363A", color:"#fdfdfd"}}
        style={{backgroundColor:"#c7c8d3", color:"#35363A", }}
        className="btn"
      >لا شكرا</Link>
      {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
    <Link 
       to={{
        pathname: "/login",
        state: { from: location }
      }}
      className="btn"
    >تسجيل الدخول</Link>
    </span>
    </div>
  </div>
}

const PrivateRoute = ({component:Component, condition,fallback:Fallback, ...rest})=>{
  return <Route 
  {...rest}
  render={(props)=>{
    return condition? <Component {...props}/>:Fallback?<Fallback {...props}/>:<Redirect to="/login"/>;
  }}
  />
}

function App() {
  const {currentUser}= useAuth();

  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" component={Landing} />
        <PrivateRoute exact path="/series" condition={currentUser} component={Series} />
        {/* <PrivateRoute exact path="/" condition={currentUser} component={Series} fallback={Landing} /> */}
        <Route
          exact
          path="/serie/:serieNbr/question/:questionNbr"
          render={({match, ...props})=>{
            const {params:{questionNbr}} = match
            if(questionNbr>10 && !currentUser) return <ShouldBeLoggedIn/>
            return <Question {...{match,...props}}/>
          }}
        />
        <PrivateRoute exact path="/serie/:serieNbr/result" condition={currentUser} component={Result} />
        <Route exact path="/signup" component={SignUp} />
        <Route exact path="/login" component={Login} />
      </Switch>
    </HashRouter>
  );
}

export default App;
